import { queryOptions, skipToken } from "@tanstack/react-query";

import { MASTER_INVALIDATION_KEY } from "@/api/queryClient";
import {
  getAuthClaims,
  getAuthSession,
  getAuthUser,
  getAuthUserPermissions,
  getAuthUserProfile,
} from "@/api/resources/auth/api";

export const authQueryKeys = {
  all: () => ["auth"],
  getAuthSession: () => [...authQueryKeys.all(), "session"],
  getAuthClaims: () => [...authQueryKeys.all(), "claims"],
  getAuthUser: () => [...authQueryKeys.all(), "user"],
  getAuthUserProfile: (id?: string) => [...MASTER_INVALIDATION_KEY, ...authQueryKeys.all(), "profile", id],
  getAuthUserPermissions: (id?: string) => [...MASTER_INVALIDATION_KEY, ...authQueryKeys.all(), "permissions", id],
};

export const authQueries = {
  getAuthSession: () =>
    queryOptions({
      queryKey: [...authQueryKeys.getAuthSession()],
      queryFn: () => getAuthSession(),
      staleTime: 0,
    }),

  getAuthClaims: () =>
    queryOptions({
      queryKey: [...authQueryKeys.getAuthClaims()],
      queryFn: () => getAuthClaims(),
      staleTime: 0,
    }),

  getAuthUser: () =>
    queryOptions({
      queryKey: [...authQueryKeys.getAuthUser()],
      queryFn: () => getAuthUser(),
    }),

  getAuthUserProfile: (id?: string) =>
    queryOptions({
      queryKey: [...authQueryKeys.getAuthUserProfile(id)],
      queryFn: id ? () => getAuthUserProfile(id) : skipToken,
    }),

  getAuthUserPermissions: (id?: string) =>
    queryOptions({
      queryKey: [...authQueryKeys.getAuthUserPermissions(id)],
      queryFn: id ? () => getAuthUserPermissions(id) : skipToken,
    }),
};
